import { Phone, Validateable } from "@models/interfaces";
import { Time } from "@models/time";
import moment from "moment";

export class Profile extends Validateable {
	private forename: string = "";
	private surname: string = "";
	private country_id: string = "";
	private birthday: Time = new Time();
	private _birthdate: string = "";
	private street: string = "";
	private city: string = "";
	private zipcode: string = "";
	private phonecode: string = ""; // Frontend field
	private phonenumber: string = ""; // Frontend field
	private mobile: string = "";
	private phone_number_verified: boolean = false;
	private visible: boolean = false;
	private accepted_terms_data: boolean = false;
	private accepted_terms_verification: boolean = false;
	private taxid: string = "";
	private business: BusinessData = new BusinessData();
	private email: string = "";
	private citizenship_id: string = "";

	// Profile was just updated with level 3 files

	public set birthdate(s: string) {
		this._birthdate = s;
	}

	public set _accepted_terms_data(b: boolean) {
		this.accepted_terms_data = b;
	}

	public get _country_id(): string {
		return this.country_id;
	}

	public set _country_id(s: string) {
		this.country_id = s;
	}

	public setAcceptedTermsVerification(b: boolean): void {
		this.accepted_terms_verification = b;
	}

	public setBirthdate(d: string): void {
		this.birthdate = d;
	}

	public initBirthdate(): void {
		this._birthdate = moment.parseZone(this.birthday.getDate()).format("DD.MM.YYYY");
	}

	public setTaxid(t: string): void {
		this.taxid = t;
	}

	public setPhoneNumberVerified(b: boolean): void {
		this.phone_number_verified = b;
	}

	public setAcceptedTermsData(b: boolean): void {
		this.accepted_terms_data = b;
	}

	public setPhone(phone: Phone): void {
		this.phonecode = phone.code;
		this.phonenumber = phone.number;
	}

	public setPhoneNumber(s: string): void {
		this.phonenumber = s;
	}

	public setMobile(mobile: string): void {
		this.mobile = mobile;
	}

	// Special methods

	public isEmpty(): boolean {
		return [this.forename, this.surname, this.country_id, this.street, this.city, this.zipcode, this.mobile].some(
			(field: string) => field === ""
		);
	}
}

class BusinessData {
	private name: string = "";

	public getBusinessName(): string {
		return this.name;
	}
}
